export default "__VITE_ASSET__CSujRqiT__"